import { Modal, ModalBody, ModalHeader } from 'components/UI';
import { useToast } from 'hooks';
import { UniqueIdentifier } from '@dnd-kit/core';
import AddCategoryForm, { CategoryFormValues } from './AddCategoryForm';

type AddCategoryProps = {
  onUpdate(arg0: string): void;
  closePopup(): void;
  containers: UniqueIdentifier[];
};

const AddCategory = ({ closePopup, onUpdate, containers }: AddCategoryProps) => {
  const [showToast] = useToast();

  const handleSubmit = async ({ categoryName }: CategoryFormValues) => {
    const isError = containers.includes(categoryName);
    closePopup();
    showToast({
      status: isError ? 'error' : 'success',
      message: isError
        ? 'Category already exists. Please enter a different name.'
        : `${categoryName} created successfully.`,
    });

    if (isError) return;

    onUpdate(categoryName);
  };

  return (
    <Modal isOpen isCloseButton closeOnEsc={false} closeOnOverlayClick isCentered size="sm" onClose={closePopup}>
      <ModalHeader textAlign="center" fontSize="4xl">
        Add Category
      </ModalHeader>
      <ModalBody pb={8}>
        <AddCategoryForm onSubmit={handleSubmit} />
      </ModalBody>
    </Modal>
  );
};

export default AddCategory;
